module.exports = __webpack_public_path__ + "static/1-13070335ef0eb30cdf015bdb410b9734.png";